import { TypeIconName } from '@bitrise/bitkit';
import { BitriseAppProjectType } from '@trace/types/src/App';

export const SIMULATOR_APP_ID = 'ab977b5dfa484b47';

export const BITRISE_APP_PROJECT_TYPE_ICON_MAP: { [key in BitriseAppProjectType]: TypeIconName } = {
  android: 'PlatformsAndroid',
  cordova: 'PlatformsCordova',
  fastlane: 'PlatformsFastlane',
  flutter: 'PlatformsFlutter',
  ionic: 'PlatformsIonic',
  ios: 'PlatformsApple',
  macos: 'PlatformsMacos',
  other: 'PlatformsOther',
  'react-native': 'PlatformsReact',
  xamarin: 'PlatformsXamarin',
};
